/* eslint-disable react/no-danger */
import { useLocale, useTranslation } from '@aviv-unified-frontend/runtime/i18n';
import { Box } from '@gemini/core';
import { Link } from '@gemini/ui';
import TermsAndConditionsContent from '@mfe-presentation/components/TermsAndConditions/TermsAndConditionsContent';
import { useAppContext } from '@mfe-presentation/contexts';
import { NAME_SPACE } from '@mfe-presentation/hooks/useLoadTranslations';

const TermsAndConditions = () => {
    const { t } = useTranslation(NAME_SPACE);
    const { locale } = useLocale();
    const { config } = useAppContext();

    const termsLinks = config?.identity?.termsAndConditions;
    return termsLinks ? (
        <Box
            borderWidth="borderWidth.1"
            borderStyle="solid"
            borderColor="color.border.light.default"
            borderRadius="radius.8"
            marginBottom="spacing.16"
        >
            <TermsAndConditionsContent>
                <span
                    dangerouslySetInnerHTML={{
                        __html: t(`step_identity.legal.dataProtection.start`),
                    }}
                />{' '}
                <Link href={termsLinks.avivWebsiteUrl[locale]} variant="inline" isExternal>
                    {t(`step_identity.legal.avivWebsiteUrl.linkText`)}
                </Link>{' '}
                {t(`step_identity.legal.dataProtection.end`)}{' '}
                {t(`step_identity.legal.privacyPolicy.start`)}{' '}
                <Link href={termsLinks.privacyPolicyUrl[locale]} variant="inline" isExternal>
                    {t(`step_identity.legal.privacyPolicy.linkText`)}
                </Link>
                . <br />
                <br /> {t(`step_identity.legal.termsAndConditionsOfService.start`)}{' '}
                <Link
                    href={termsLinks.termsAndConditionsOfServiceUrl[locale]}
                    variant="inline"
                    isExternal
                >
                    {t(`step_identity.legal.termsAndConditionsOfService.linkText`)}
                </Link>{' '}
                {t(`step_identity.legal.termsAndConditionsOfService.end`)}
            </TermsAndConditionsContent>
        </Box>
    ) : null;
};

export default TermsAndConditions;
